import { isNil, isEmpty, isMatch } from 'lodash';
import { CHAT_AGENT_ACTION_STATUS } from '../config/chatAgentActionStatus';
import { CHAT_AGENT_ACTION_TYPE } from '../config/chatAgentActionType';
import { CHAT_AGENT_COMPONENT } from '../config/chatAgentComponentGA';

export const getChatAgentGAValue = (
    { type, data, actionMetadata: { type: metadataType } = {}, status },
    event = null
) => {
    let isApplied;
    if (status === CHAT_AGENT_ACTION_STATUS.SUCCESS && event) {
        const { data: recommendedValues } =
            event?.actions.find(action => action.type === CHAT_AGENT_ACTION_TYPE.SET_RECOMMENDED_DATA) || {};
        const currentValues = data?.result || data || {};
        isApplied = !isEmpty(currentValues) && isMatch(currentValues, recommendedValues);
    }
    const values = [CHAT_AGENT_COMPONENT, type, metadataType, status, isApplied];
    return values.filter(val => !isNil(val)).join('_');
};
